import React from "react";
import "./footer.css";
import { FaFacebook } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoLogoTwitter } from "react-icons/io";

const Footer = () => {
  return (
    <footer>
      <a href="#home" className="footer__logo">
        nazib
      </a>
      <ul className="permalinks">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://facebook.com/na2ibb"
        >
          <FaFacebook />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://instagram.com/na2ibb"
        >
          <FiInstagram />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://x.com/__nazib__"
        >
          <IoLogoTwitter />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; nazib. All rights reserved</small>
      </div>
    </footer>
  );
};

export default Footer;
